import { useState } from 'react'
import { Eye, PencilLine } from 'lucide-react'
import CkEditorField from '../../components/CkEditorField'
import SegmentedControl from '../../components/SegmentedControl'
import { templatesStrings as S } from './strings'
import { safePreviewHtml } from './safePreviewHtml'

/**
 * One HTML surface of a phishing template — the email body, the landing page, or the page
 * shown after someone is caught — with the legacy's two tabs over it.
 *
 * THE LEGACY HAS EXACTLY THIS: each of its three surfaces sits in a two-tab nav, `RichText`
 * and `Preview`, where the preview is an iframe re-fed from `editor.getData()` on every
 * change (`PhishingTemplates/js.cshtml:214-219`). Raw HTML editing is not a third tab there
 * and is not one here — it is the editor's own `sourceEditing` toolbar button, which is why
 * this loads the build that has it.
 *
 * TWO DEPARTURES FROM THE LEGACY, both deliberate:
 *
 *  - The preview is SANDBOXED. The legacy's iframe is not, and what it renders is markup
 *    written to impersonate a bank, inside the admin panel, for the person signed in. An
 *    empty `sandbox` gives it an opaque origin and no scripts, no forms, no navigation.
 *  - It uses `srcDoc` rather than `"data:text/html," + escape(html)`. `escape` is deprecated
 *    and mangles anything outside Latin-1 — which is every Arabic template in the library.
 *
 * The editor stays MOUNTED while the preview shows. Unmounting it would destroy the CKEditor
 * instance and its undo history on every glance at the result.
 */
export default function TemplateSurfaceEditor({ id, value, onChange, dir = 'rtl' }) {
  const [tab, setTab] = useState('compose')

  return (
    <div className="tpl-surface-editor">
      <SegmentedControl
        variant="underline"
        value={tab}
        onChange={setTab}
        ariaLabel={S.content.title}
        items={[
          { id: 'compose', label: S.content.tabs.compose, icon: PencilLine },
          { id: 'preview', label: S.content.tabs.preview, icon: Eye },
        ]}
      />

      {/* Hidden, not unmounted — see above. */}
      <div hidden={tab !== 'compose'}>
        <CkEditorField id={id} value={value} onChange={onChange} dir={dir} />
      </div>

      {tab === 'preview' && (
        <iframe
          className="tpl-surface-editor__preview"
          srcDoc={safePreviewHtml(value)}
          sandbox=""
          title={S.content.tabs.preview}
        />
      )}
    </div>
  )
}
